import { colors } from '../themeCore';

export const specialButtonTheme: ButtonTheme = {
    background: colors.gold400,
    border: colors.gold400,
    text: colors.gray0,

    hoverBackground: colors.gold500,
    hoverBorder: colors.gold500,
};

export const primaryButtonTheme: ButtonTheme = {
    background: colors.cocoa800,
    border: colors.cocoa800,
    text: colors.gray0,

    hoverBackground: colors.cocoa900,
    hoverBorder: colors.cocoa900,
};

export const secondaryButtonTheme: ButtonTheme = {
    background: 'transparent',
    border: colors.cocoa200,
    text: colors.cocoa800,

    hoverBackground: colors.cocoa100,
    hoverBorder: colors.cocoa200,
};

export const tertiaryButtonTheme: ButtonTheme = {
    background: colors.cocoa100,
    border: colors.cocoa100,
    text: colors.cocoa800,

    hoverBackground: colors.cocoa200,
    hoverBorder: colors.cocoa200,
};

export const ghostButtonTheme: ButtonTheme = {
    background: 'transparent',
    border: 'transparent',
    text: colors.gold500,

    hoverBackground: colors.cocoa100,
    hoverBorder: colors.cocoa100,
};

export const destructiveButtonTheme: ButtonTheme = {
    background: 'transparent',
    border: colors.red300,
    text: colors.red300,

    hoverBackground: colors.red0,
    hoverBorder: colors.red300,
};
